import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Card, Checkbox, Typography } from '@mui/material';
import { Assignment } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import MainCard from '../../../component/cards/MainCard';

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.dark,
    color: '#fff',
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
    transition: '0.2s ease-in-out',
    '&:hover': {
        boxShadow: 6,
        transform: 'scale(1.02)'
    }
}));

const StyledAssignmentIcon = styled(Assignment)(() => ({
    width: '70px',
    height: '70px',
    color: '#fff'
}));

function ExistingQuestionnaireCard({
    questionnaire,
    selectionMode,
    selected,
    onToggleSelect
}) {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleClick = () => {
        if (selectionMode) {
            onToggleSelect();
        } else {
            navigate(`/questionarios/${questionnaire.uuid}`);
        }
    };

    return (
        <CardWrapper onClick={handleClick} content={false}>
            <Card
                elevation={0}
                sx={{
                    display: 'flex',
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }}
            >
                {selectionMode && (
                    <Box position="absolute" top={8} left={8} zIndex={2}>
                        <Checkbox
                            checked={selected}
                            onChange={onToggleSelect}
                            onClick={(e) => e.stopPropagation()}
                            sx={{ color: '#fff' }}
                        />
                    </Box>
                )}
                <Box
                    sx={{
                        display: 'flex',
                        width: '45%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: theme.palette.secondary.dark
                    }}
                >
                    <StyledAssignmentIcon />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        width: '150%',
                        height: '140px',
                        padding: '12px'
                    }}
                >
                    <Typography variant="h3" color="#fff" sx={{ pb: 1 }}>
                        {questionnaire.name}
                    </Typography>
                    <Typography variant="h4" color="#d6d5d5">
                        {questionnaire.description}
                    </Typography>
                </Box>
            </Card>
        </CardWrapper>
    );
}

ExistingQuestionnaireCard.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    questionnaire: PropTypes.shape({
        uuid: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
    }).isRequired
};

export default ExistingQuestionnaireCard;
